import { createFileRoute, notFound, Outlet } from "@tanstack/react-router"
import NotFound from "~/components/reusable/NotFound"
import LoadingOverlay from "~/components/reusable/LoadingOverlay"
import { fiscalYearParamSchema } from "~/utils/budgetYear"

export const Route = createFileRoute("/_auth/budgets/_layout/$fiscalYear")({
  params: {
    parse: ({ fiscalYear }) => {
      const parsed = fiscalYearParamSchema.safeParse(fiscalYear)
      if (!parsed.success) throw notFound()
      return { fiscalYear: parsed.data }
    },
    stringify: ({ fiscalYear }) => ({ fiscalYear: String(fiscalYear) }),
  },
  // A fiscal year's pages, its budgets' included, exist only once it has a target.
  loader: async ({ params, context }) => {
    const targets = await context.trpcUtils.fiscalYearTarget.getAll.fetch()
    if (!targets.some((target) => target.fiscalYear === params.fiscalYear)) throw notFound()
  },
  pendingComponent: () => <LoadingOverlay />,
  notFoundComponent: NotFound,
  component: Outlet,
})
